import { useCallback } from 'react';

import { httpJson as _httpJson } from './';
import type { HttpRequest } from './httpRequestBuilder';

export interface OtherOptions {
  cache?: boolean;
  signal?: AbortSignal;
}

interface UseHttpRequest extends RequestInit {}

const useHttp = () => {
  const httpJson = useCallback(<T>(url: string, options: UseHttpRequest) => {
    const _options: HttpRequest = {
      ...options,
    };

    return _httpJson<T>(url, _options);
  }, []);

  return { httpJson };
};

export default useHttp;
